export const openNativeGetImgDialog = null;
